var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBook = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M9.375 15.938a1.5 1.5 0 0 1 1.5-1.5h5.063V3.563H11.25A2.25 2.25 0 0 0 9 5.813V6m0 9.938V5.813a2.25 2.25 0 0 0-2.25-2.25H2.063v10.875h5.062a1.5 1.5 0 0 1 1.5 1.5" }) }))); };
export default SvgBook;
